import { useCallback } from 'react';
import posthog from 'PostHog/posthog-client';

type EventProperties = Record<string, unknown>;

const posthogProjectToken = import.meta.env.VITE_POSTHOG_KEY;

export const trackEvent = (
  eventName: string,
  properties?: EventProperties,
): void => {
  if (!posthogProjectToken || !eventName) {
    return;
  }

  posthog.capture(eventName, properties);
};

export const registerEventProperties = (properties: EventProperties = {}): void => {
  if (!posthogProjectToken) {
    return;
  }

  posthog.register(properties);
};

export const useTrackEvent = () =>
  useCallback(
    (eventName: string, properties?: EventProperties) =>
      trackEvent(eventName, properties),
    [],
  );
